module.exports = __webpack_public_path__ + "img/oohirasan.2bd3dbdc.jpg";